<div class="accordion lesson-list" id="accordionLesson">
    <div class="lesson-row shadow-sm-darker" *ngFor="let lesson of lessons; let i = index">
        <div class="lesson-row__head">
            <button type="button" class="lesson-row__toggle" id="{{lesson.id}}" data-toggle="collapse"
                [attr.data-target]="getHTMLIDRef(lesson.id)" aria-expanded="false"
                aria-controls="collapse{{lesson.id}}">
                <span class="lesson-row__num" [class.lesson-row__num--done]="!admin && lesson.completed">
                    <i *ngIf="!admin && lesson.completed" class="fa fa-check" aria-hidden="true"></i>
                    <ng-container *ngIf="admin || !lesson.completed">{{i + 1}}</ng-container>
                </span>
                <span class="lesson-row__text">
                    <span class="lesson-row__title">{{lesson.title}}</span>
                    <span class="lesson-row__meta">
                        <span *ngIf="lesson.timenumber > 0"><i class="far fa-clock" aria-hidden="true"></i>
                            {{lesson.timenumber}} {{lesson.timeunit == 0 ? "Minute(s)" : "Hour(s)"}}</span>
                        <span *ngIf="lesson.startdate && !admin"><i class="far fa-calendar" aria-hidden="true"></i>
                            {{lesson.startdate}}</span>
                    </span>
                </span>
                <span *ngIf="!admin && lesson.completed" class="lesson-row__status">Completed</span>
                <span *ngIf="!admin && savedLessonIds.has(lesson.id)" class="lesson-row__status">Saved</span>
                <i class="fa fa-angle-down lesson-row__chevron" aria-hidden="true"></i>
            </button>
            <span class="lesson-row__actions" *ngIf="admin">
                <button type="button" (click)="movelessonup($event, lesson.id, lesson.title, lesson.moduleid)"
                    class="move-lesson-btn fa fa-arrow-up" title="Move Up" aria-label="Move lesson up"></button>
                <button type="button" (click)="movelessondown($event, lesson.id, lesson.title, lesson.moduleid)"
                    class="move-lesson-btn fa fa-arrow-down" title="Move Down" aria-label="Move lesson down"></button>
            </span>
        </div>
        <div id="collapse{{lesson.id}}" class="collapse hide" aria-labelledby="{{lesson.id}}"
            data-parent="#accordionLesson">
            <div class="lesson-row__body">
                <div class="innerHTML-wrap" [innerHTML]="lesson.description"></div>
                <button type="button" class="btn btn--sm lesson-row__go" routerLink="/user/lesson"
                    [queryParams]="{classid: lesson.id, moduleid:lesson.moduleid}"
                    [disabled]="!canViewLessons || (offlineDegraded && !savedLessonIds.has(lesson.id))">
                    Go To Lesson <i class="fa fa-angle-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</div>
